import React from 'react';
import Table from 'react-bootstrap/Table';
import PaginationComponent from '../Pagination/PaginationComponent';
import styles from './Grid.module.css';

const Grid = ({ headers, data, renderRow, className = '', itemsPerPage, totalItems, paginate, currentPage, headerStyles = null, ...rest }) => {
    return (
        <div>
            <Table className={`${styles.customTable} ${className}`} striped bordered hover {...rest}>
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index} className={headerStyles ? headerStyles[header.className] : null}>
                                {header.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => renderRow(row, index))}
                </tbody>
            </Table>
            {totalItems > itemsPerPage && (
                <PaginationComponent
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    paginate={paginate}
                    currentPage={currentPage}
                />
            )}
        </div>
    );
};

export default Grid;